import { Component, ElementRef, ViewChild } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { Retailer, RetailerWithLocations } from 'src/models/Retailer';
import { RetailerLocation } from 'src/models/RetailerLocation';
import { RetailerLocationViewModel } from 'src/viewmodels/RetailerLocationViewModel';
import { ApiService } from './api.service';
import { LocalitiAuthService } from './localiti-auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(public auth: LocalitiAuthService, public fauth: AngularFireAuth, private router: Router, private api: ApiService) {
    
    router.events.subscribe(nav => {
      if (nav instanceof NavigationEnd) {
        this.sidenav.close();
      }
    });
    
    this.auth.userRefresh.subscribe(u => {
      console.log("user sub called");
      setTimeout(async () => {
        console.log("updating retailers");
        this.updateLocations();
    })
 
  });
}
ngOnInit() {
  setTimeout(() => {
  this.updateLocations();
}, 100)
}

  // async offersExpanded(loc: RetailerLocationViewModel) {
  //   const offers = await this.api.getOffersForRetailerLocation(loc.id);
  //   loc.offers = offers;
  // }

  private async updateLocations() {
    if ((await this.auth.isRetailer)) {
    this.retailers = await this.api.getRetailersWithLocations();
    } else {
      this.retailers = [];
    }
  }

  title = 'localiti';
  @ViewChild("sidenav") sidenav: MatSidenav;
  menuToggle() {
    this.sidenav.toggle()
  }
  retailers: RetailerWithLocations[] = [];

  async logout() {
    await this.auth.signOut();
    this.router.navigate([""]);
  }
}
